import React from 'react';
import Color from 'color';
import PropTypes from 'prop-types';
import Panel from '../../../Panel';
import ColorPicker from '../../../../Form/ColorPicker';
import { FEATURE_COLOR } from '../../../../../lib/constants';
import noop from 'lodash-es/noop';

export default function FeatureColorEditor(props) {
  let currentColor = new Color(props.feature.properties.color);

  return (
    <Panel title='Select Color' divider={true}>
      <ColorPicker
        colorOptions={Object.values(FEATURE_COLOR).map((color) => color.hex)}
        name='waypoint-color'
        value={currentColor.hex()}
        onChange={props.onChange}
      />
    </Panel>
  );
}

FeatureColorEditor.propTypes = {
  feature: PropTypes.object,
  onChange: PropTypes.func,
};

FeatureColorEditor.defaultProps = {
  onChange: noop
};
